/**
 * Status badge component for workspace status
 */

import type { ReactElement } from 'react';
import type { WorkspaceStatus } from '../types';

interface WorkspaceStatusBadgeProps {
  status: WorkspaceStatus;
}

const STATUS_LABELS: Record<WorkspaceStatus, string> = {
  building: 'Building',
  starting: 'Starting',
  running: 'Running',
  terminated: 'Terminated',
  error: 'Error',
};

export function WorkspaceStatusBadge({ status }: WorkspaceStatusBadgeProps): ReactElement {
  return (
    <span className={`status-badge status-badge--${status}`}>
      {(status === 'building' || status === 'starting') && <span className="status-badge__spinner" />}
      {STATUS_LABELS[status]}
    </span>
  );
}
